import { render, staticRenderFns } from "./DiscountDefault.vue?vue&type=template&id=1e61b2a7&"
import script from "./DiscountDefault.vue?vue&type=script&lang=js&"
export * from "./DiscountDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports